import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Grid, Tabs, Tab, TextField, Typography } from '@mui/material';
import AgreementDataTab from './AgreementDataTab';
import ResidenceWorkedHoursTab from './ResidenceWorkedHoursTab';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

type ExportModalProps = {
  isOpen: boolean;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
  filterOperationalManager?: string;
  filterResidenceGroup?: number;
  filterRegion?: number;
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function ExportModal({ isOpen, setIsOpen }: ExportModalProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClose = () => setIsOpen?.(false);

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth={true} maxWidth="md">
      <DialogTitle>
        <span className="font-bold text-neutral-600">Dataexport</span>
      </DialogTitle>
      <DialogContent>
        <Grid item>
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange}>
                <Tab
                  // TODO: MUI V5 remove
                  sx={{ '&.Mui-selected': { color: 'black' } }}
                  label="Avtal data"
                  {...a11yProps(0)}
                />
                <Tab
                  // TODO: MUI V5 remove
                  sx={{ '&.Mui-selected': { color: 'black' } }}
                  label="Arbetade timmar"
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <AgreementDataTab handleClose={handleClose} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ResidenceWorkedHoursTab handleClose={handleClose} />
            </TabPanel>
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
